export const build = { date:"2026-05-08.1335", stage:"alpha" }
